/* mm-sepet-mini.js — mini sepet (başlık çantası katmanı) ve mobil "Product added" paneli.
   Olaylar: dinler  mm:sepete-eklendi {item, cart}  → içeriği Section Rendering ile yeniler; ≥768 mm:minisepet-ac, <768 alt panel.
                    mm:sepet-yenile               → içeriği yeniden çeker (sepet sayfası değişikliklerinden sonra).
            gönderir mm:sepet {item_count}         → kaldırma sonrası başlık sayacı / sepet sayfası. */
(() => {
  if (window.mmMiniSepet) return;
  window.mmMiniSepet = {};
  const MD = window.matchMedia('(min-width: 768px)');
  const kok = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const BOLUM = 'mm-sepet-mini';

  const katman = () => document.querySelector('[data-mm-minisepet]');
  const kaydiriciKur = (el) => { if (!el) return; if (window.mmKaydirici && window.mmKaydirici.tara) window.mmKaydirici.tara(el); else el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: BOLUM } })); };

  function icerikYaz(html) {
    const k = katman(); if (!k || !html) return null;
    const d = new DOMParser().parseFromString(html, 'text/html');
    const yeni = d.querySelector('[data-mm-mini-icerik]'); if (!yeni) return null;
    const eski = k.querySelector('[data-mm-mini-icerik]');
    if (eski) eski.replaceWith(yeni); else k.appendChild(yeni);
    kaydiriciKur(yeni);
    return yeni;
  }

  async function yenile(urunId) {
    try {
      if (urunId) {
        const r = await fetch(`${kok()}recommendations/products?product_id=${encodeURIComponent(urunId)}&limit=8&section_id=${BOLUM}`);
        if (r.ok) { const html = await r.text(); if (icerikYaz(html)) return; }
      }
      const r = await fetch(`${kok()}?sections=${BOLUM}`);
      const j = await r.json();
      icerikYaz(j[BOLUM]);
    } catch (e) { /* ağ hatası: mevcut içerik kalır */ }
  }

  /* ----- Mobil "Product added" paneli ----- */
  const panel = () => document.querySelector('[data-mm-eklendi]');
  let sonOdak = null;
  function panelAc(key) {
    const p = panel(); const k = katman(); if (!p || !k) return;
    const oge = k.querySelector(`.mm-mini__oge[data-key="${CSS.escape(key || '')}"]`) || k.querySelector('.mm-mini__oge');
    if (!oge) return;
    const al = (s) => oge.querySelector(s);
    const gorsel = al('[data-mm-mini-gorsel] img');
    p.querySelector('[data-mm-eklendi-gorsel]').innerHTML = gorsel ? gorsel.outerHTML : '';
    p.querySelector('[data-mm-eklendi-ad]').textContent = (al('[data-mm-mini-ad]') || {}).textContent || '';
    const birim = al('[data-mm-mini-birim]');
    p.querySelector('[data-mm-eklendi-fiyat]').textContent = birim ? birim.content.textContent.trim() : ((al('[data-mm-mini-fiyat]') || {}).textContent || '');
    const b = al('[data-mm-mini-beden]'); const rn = al('[data-mm-mini-renk]');
    p.querySelector('[data-mm-eklendi-beden]').innerHTML = b ? b.innerHTML : '';
    p.querySelector('[data-mm-eklendi-renk]').innerHTML = rn ? rn.innerHTML : '';
    sonOdak = document.activeElement;
    p.classList.add('is-acik');
    const dlg = p.querySelector('[role="dialog"]'); dlg && dlg.focus({ preventScroll: true });
  }
  function panelKapat() {
    const p = panel(); if (!p || !p.classList.contains('is-acik')) return;
    p.classList.remove('is-acik');
    if (sonOdak && sonOdak.focus) sonOdak.focus({ preventScroll: true });
  }

  /* ----- Masaüstü: başlık katmanını açar (3 sn sonra kapanmayı başlık yönetir, üzerindeyken açık kalır) ----- */
  function katmanAc() { document.dispatchEvent(new CustomEvent('mm:minisepet-ac')); }

  async function eklendi(e) {
    const d = (e && e.detail) || {};
    let item = d.item || null;
    if (item && Array.isArray(item.items)) item = item.items[0];
    await yenile(item && item.product_id);
    if (MD.matches) katmanAc(); else panelAc(item && item.key);
  }

  async function kaldir(key, dugme) {
    const govde = katman() && katman().querySelector('[data-mm-mini-govde]');
    govde && govde.classList.add('is-yukleniyor');
    try {
      const url = ((window.routes && window.routes.cart_change_url) || `${kok()}cart/change`) + '.js';
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0, sections: [BOLUM] }) });
      const j = await r.json();
      if (j.sections && j.sections[BOLUM]) icerikYaz(j.sections[BOLUM]); else await yenile();
      if (typeof j.item_count === 'number') document.dispatchEvent(new CustomEvent('mm:sepet', { detail: { item_count: j.item_count, kaynak: 'mini' } }));
    } catch (err) {
      govde && govde.classList.remove('is-yukleniyor');
    }
  }

  function kur() {
    Object.assign(window.mmMiniSepet, { yenile, panelAc, panelKapat });
    const p = panel();
    if (p && p.parentElement !== document.body) document.body.appendChild(p);
    document.addEventListener('mm:sepete-eklendi', eklendi);
    document.addEventListener('mm:sepet-yenile', () => yenile());
    document.addEventListener('click', (e) => {
      const sil = e.target.closest('[data-mm-mini-sil]');
      if (sil) { e.preventDefault(); kaldir(sil.dataset.mmMiniSil, sil); return; }
      if (e.target.closest('[data-mm-eklendi-kapat]')) panelKapat();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') panelKapat(); });
    MD.addEventListener('change', () => { if (MD.matches) panelKapat(); });
  }
  if (document.readyState !== 'loading') kur(); else document.addEventListener('DOMContentLoaded', kur);
})();
